<template>
  <div class="bg-white p-4 rounded-md flex flex-col min-h-0">
    <div class="flex items-center justify-between gap-3 pb-2">
      <p class="font-bold text-xl tracking-tight text-gray-900">Récapitulatif</p>
    </div>

    <div class="mt-2 space-y-3">
      <SummarySellerSection
        v-if="sellerCompleteName"
        :sellerCompleteName="sellerCompleteName"
        @edit="$emit('edit', 'seller')"
      />

      <SummaryAdvisorySection
        v-if="showAdvisorySection"
        :advisoryAnswer="advisoryAnswer"
        @edit="$emit('edit', 'advisory')"
      />

      <SummaryProductSection
        v-if="productData"
        :product="product"
        :productless="productless"
        @edit="$emit('edit', 'product')"
      />

      <SummaryCustomerSection
        v-if="customerData"
        :customer="customer"
        :address="address"
        :isProfessional="isProfessional"
        @edit="$emit('edit', 'customer')"
      />
    </div>
  </div>
</template>

<script>
import { isPresent } from "@estaly/ui";
import SummarySellerSection from "./SummarySellerSection.vue";
import SummaryProductSection from "./SummaryProductSection.vue";
import SummaryAdvisorySection from "./SummaryAdvisorySection.vue";
import SummaryCustomerSection from "./SummaryCustomerSection.vue";

export default {
  components: {
    SummarySellerSection,
    SummaryProductSection,
    SummaryAdvisorySection,
    SummaryCustomerSection,
  },
  emits: ["edit"],
  props: {
    sellerCompleteName: {
      type: String,
      default: "",
    },
    product: {
      type: Object,
      default: () => ({}),
    },
    customer: {
      type: Object,
      default: () => ({}),
    },
    address: {
      type: Object,
      default: () => ({}),
    },
    contractType: {
      type: String,
      default: null,
    },
    productless: {
      type: Boolean,
      default: false,
    },
    advisoryAnswer: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    isProfessional() {
      return this.advisoryAnswer?.usageType === "professional";
    },

    productData() {
      return isPresent(this.product?.title) || isPresent(this.product?.referenceId) || isPresent(this.product?.price);
    },

    customerData() {
      return (
        isPresent(this.customer?.firstName) ||
        isPresent(this.customer?.lastName) ||
        isPresent(this.customer?.email) ||
        isPresent(this.customer?.phone)
      );
    },

    showAdvisorySection() {
      return this.advisoryData && Object.keys(this.advisoryData).length > 0;
    },

    advisoryData() {
      const c = this.advisoryAnswer || {};
      const hasAny =
        c.usageType != null ||
        (c.risks && c.risks.length > 0) ||
        c.offerType != null ||
        c.hasExistingInsurance !== undefined ||
        c.electronicDevicesValue != null;
      return hasAny ? c : null;
    },
  },
};
</script>
